import { isPlainObject } from 'lodash';
import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export function fetch(params = {}, rest = {}) {
    return axios.get('/review/list', { params, ...rest }).then(({ data }) => {
        if (data && Array.isArray(data.items)) {
            return data.items;
        }
        throw new ApiRequestError('Failed fetch reviews /review/list', { params, rest });
    });
}

export function fetchById(id, params = {}, rest = {}) {
    return axios.get(`/review/${id}`, { params, ...rest }).then(({ data }) => {
        if (data.items && isPlainObject(data.items)) {
            return data.items;
        }
        throw new ApiRequestError(`Failed fetch reviews /review/${id}`, { id, params, rest });
    });
}
